import Alpine from "alpinejs";
import Swiper, { Autoplay } from "swiper";
import { CountUp } from "countup.js";
import "swiper/swiper-bundle.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

Swiper.use([Autoplay]);

// Parameters for header nav color handling
let body = document.getElementById("body");
let menuPrimary = document.getElementById("menu-primary");
let menuWrapper = document.getElementById("menu-wrapper");

// GSAP animations
function initGsap() {
	gsap.registerPlugin(ScrollTrigger);

	const xyOffset = 50;
	const duration = 0.8;

	gsap.utils.toArray(".fade-from-bottom").forEach((el) => {
		gsap.fromTo(
			el,
			{ autoAlpha: 0, y: xyOffset, visibility: "visible" },
			{
				scrollTrigger: {
					trigger: el,
					once: true,
				},
				delay: el.dataset.fadedelay || 0.2,
				duration: duration,
				autoAlpha: 1,
				y: 0,
			}
		);
	});
	gsap.utils.toArray(".fade-from-top").forEach((el) => {
		gsap.fromTo(
			el,
			{ autoAlpha: 0, y: -xyOffset, visibility: "visible" },
			{
				scrollTrigger: {
					trigger: el,
					once: true,
				},
				delay: el.dataset.fadedelay || 0.2,
				duration: duration,
				autoAlpha: 1,
				y: 0,
			}
		);
	});
	gsap.utils.toArray(".fade-from-left").forEach((el) => {
		gsap.fromTo(
			el,
			{ autoAlpha: 0, x: -xyOffset, visibility: "visible" },
			{
				scrollTrigger: {
					trigger: el,
					once: true,
				},
				delay: el.dataset.fadedelay || 0.2,
				duration: duration,
				autoAlpha: 1,
				x: 0,
			}
		);
	});
	gsap.utils.toArray(".fade-from-right").forEach((el) => {
		gsap.fromTo(
			el,
			{ autoAlpha: 0, x: xyOffset, visibility: "visible" },
			{
				scrollTrigger: {
					trigger: el,
					once: true,
				},
				delay: el.dataset.fadedelay || 0.2,
				duration: duration,
				autoAlpha: 1,
				x: 0,
			}
		);
	});
}

// CountUps
window.onload = function () {
	const countUps = document.getElementsByClassName("countup");

	let observer = new IntersectionObserver(
		function (entries) {
			Array.prototype.forEach.call(entries, function (entry) {
				if (entry.isIntersecting === true) {
					if (!entry.target) return;

					// Init Countup on the object
					let countTo = entry.target.dataset.countto;

					if (countTo) {
						let countUp = new CountUp(entry.target, countTo, {
							separator: ".",
							duration: 3,
						});

						countUp.start();
						observer.unobserve(entry.target);
					}
				}
			});
		},
		{ threshold: [0] }
	);

	if (countUps.length) {
		Array.prototype.forEach.call(countUps, function (el) {
			observer.observe(el);
		});
	}
};

document.addEventListener("DOMContentLoaded", function () {
	initGsap();

	window.Alpine = Alpine;

	Alpine.start();

	// Parameters for header nav color handling
	body = document.getElementById("body");
	menuPrimary = document.getElementById("menu-primary");
	menuWrapper = document.getElementById("menu-wrapper");

	// Init quote swiper
	const swiper = new Swiper(".quoteSwiper", {
        // direction: 'vertical',
		loop: true,
		autoHeight: false,
		autoplay: {
			delay: 3000,
		},
		speed: 1200,
	});

    // Check scroll
    changeMenuBg();
});

// Set header nav colors based on scroll position
document.addEventListener("scroll", (el) => changeMenuBg());

// Callback for scroll
function changeMenuBg() {
    let scrolled = document.scrollingElement.scrollTop;
    let position = body.offsetTop;

    // Only if front page
    if (document.location.pathname == "/") {
        if (scrolled > position + 100) {
            menuWrapper.classList.remove("bg-transparent");
            menuWrapper.classList.add("bg-white");
            menuWrapper.classList.remove("xl:text-white");
            menuWrapper.classList.add("xl:text-black");
            menuPrimary.classList.remove("text-white");
            menuPrimary.classList.add("text-black");
        } else {
            menuWrapper.classList.remove("bg-white");
            menuWrapper.classList.add("bg-transparent");
            menuWrapper.classList.remove("xl:text-black");
            menuWrapper.classList.add("xl:text-white");
            menuPrimary.classList.remove("text-black");
            menuPrimary.classList.add("text-white");
        }
    } else {
        // Always add white bg on other pages
        menuWrapper.classList.remove("bg-transparent");
        menuWrapper.classList.add("bg-white");
    }
}

// Setup Alpine data
document.addEventListener("alpine:init", () => {
	Alpine.data("menuPrimary", () => ({
		isMenuOpen: false,
	}));

	Alpine.data("videoModal", () => ({
		showModal: false,
		modal: document.getElementById("modal"),
		modalVideo: document.getElementById("modal-video"),
		startVideo() {
			this.modalVideo.play();
		},
		stopVideo() {
			this.modalVideo.stop();
		},
		addIframe(url) {
			let iframe = document.createElement("iframe");
			iframe.src = url;
			iframe.id = "modal-iframe";
			modal.appendChild(iframe);
		},
		deleteIframe() {
			modal.removeChild(document.getElementById("modal-iframe"));
		},
		closeModal() {
            this.modalVideo.pause();
            this.modalVideo.currentTime = 0;
			this.showModal = false;
		},
	}));

	Alpine.data("body", () => ({}));

	Alpine.data("positionList", () => ({
		showMore() {
			let cap = 5;
			let i = 0;
			for (let box of this.$refs.joblist.children) {
				if (box.classList.contains("hidden")) {
					i++;
					box.classList.remove("hidden");
				}
				if (i > cap - 1) break;
			}
			if (i == 0 || i < cap) {
				this.$refs.loadmoreButton.disabled = true;
				this.$refs.loadmoreButtonLabel.innerHTML = "Inga mer jobb att visa";
			}
		},
	}));
});
